import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/public/ac.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/AMS2_Square.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/Assetto_Corsa_Competizione.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/CareerHeader_1_1.jpg");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/190e-gra.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/911-rsr74.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/BMW-M3-GTR.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/brasil-stock-99.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/brazilian-historics.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/BSC_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/CART_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/cat-620.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Club_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/copa-uno.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/corvette-c3r.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Dirt_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Dirt_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/DTM_AMG.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f-inter.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f-junior.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f-trainer.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/F-USA.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f-vee-fin.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f-vintage-g1m1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/f3-brasil.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/FE_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/formula-60s.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/FUA_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/GC_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/GT1_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/GT3_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Jaguar_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Jaguar_3.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/kart-rental.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/kart-shifter.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Lmdh_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/LmdhPorsche_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/LmdhPorsche_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/lotus-98t.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/m1-procar.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/man-ct.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Mclaren_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Mini.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/nissan-gtr-gt3.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/nissan-r390-gt1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/opala-oldstock.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/P1_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Porsche_1.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Porsche_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Porsche_3.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/Porsche_919.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/SprintRace.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/super-kart.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/super-v8.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/TCR_2.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/TCR_3.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/vintage-tc.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/cars/vw-ct.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/games-standalone.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/iRacing-Icon-Color-White.svg");
import(/* webpackMode: "eager" */ "/vercel/path0/public/LeMans-Logo-small.svg");
import(/* webpackMode: "eager" */ "/vercel/path0/public/r3e-white.png");
import(/* webpackMode: "eager" */ "/vercel/path0/public/rennsport.svg");
import(/* webpackMode: "eager" */ "/vercel/path0/public/RFactor2_Logo.png");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/projects/career/_component/complextManagment.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/projects/career/_component/FullCareer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/FAQ.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/ModalAsButton.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/WaitlistCTA.tsx")